import React from 'react';
import {observer} from 'mobx-react';
import {HTMLDialog, Title, Text, Flex, Button} from '@priority-software/priority-style-react';
import {selectCompanyStore} from './SelectCompanyStore';
import {SearchableList} from './SearchableList';
import {
    SELECT_COMPANY_DIALOG,
    selectCompDataTestId,
    selectPrivDataTestId,
    licenseSectionDataTestId,
    confirmBtnDataTestId
} from './consts';
import styles from './styles.module.scss';
import {changeCompanyStatic} from '../../_shared/GWTBridge/invoke/genPage';
import {createDataTestId} from '../../utils/dataTestId';
import {getLocalizedText, texts} from '../../constants/TextConst';

export const SelectCompanyDlg = observer(() => {
    const {
        companies,
        company,
        isOpen,
        canCancel,
        licensedto,
        privilegeGroup,
        setCompany,
        setIsOpen,
        setCanCancel,
        setPrivilegeGroup,
        getProfile
    } = selectCompanyStore;

    const onSelectCompany = item => {
        setCompany(item?.value);
    };

    const onSelectPrivilege = item => {
        setPrivilegeGroup(item?.value);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const onConfirm = () => {
        const profile = getProfile();
        changeCompanyStatic(company.dname, profile);
        setCanCancel(true);
        handleClose();
    };

    const companyOptions = companies?.map(company => {
        return {
            label: company.title,
            value: company.dname,
            data: company
        };
    });

    const privilegeOptions = company?.EnvProfile?.map(profile => {
        return {
            label: profile.profilename,
            value: profile.profilename,
            data: profile
        };
    });

    const isSmallScreen = window?.screen?.width <= 1280;
    const isLargeScale = window?.devicePixelRatio >= 1.5;
    const maxScrollHeight = isSmallScreen && isLargeScale ? 220 : null;

    return isOpen ? (
        <HTMLDialog
            id={SELECT_COMPANY_DIALOG}
            isOpen={isOpen}
            onClose={handleClose}
            maskClosable={false}
            closable={canCancel}
            escClosable={canCancel}
            toolbarContent={
                <Title
                    skin="h2"
                    textColor="primary-700"
                    text={getLocalizedText(texts.selectCompany)}
                />
            }
            content={
                <Flex
                    direction="column"
                    alignItems="flex-start"
                    componentClasses={styles.dialogContent}
                >
                    {!!companyOptions.length && (
                        <SearchableList
                            label={getLocalizedText(texts.company)}
                            options={companyOptions}
                            currValue={company?.title}
                            onSelect={onSelectCompany}
                            dataTestId={selectCompDataTestId}
                            maxScrollHeight={maxScrollHeight}
                        />
                    )}
                    {!!privilegeOptions?.length && (
                        <SearchableList
                            label={getLocalizedText(texts.privilegeGroup)}
                            options={privilegeOptions}
                            currValue={privilegeGroup.profilename}
                            onSelect={onSelectPrivilege}
                            dataTestId={selectPrivDataTestId}
                            maxScrollHeight={maxScrollHeight}
                        />
                    )}
                    {!privilegeOptions?.length && licensedto && (
                        <Flex
                            direction="column"
                            alignItems="flex-start"
                            {...createDataTestId(licenseSectionDataTestId, true)}
                        >
                            <Text skin="paragraph-2">{getLocalizedText(texts.licensedTo)}</Text>
                            <Text skin="paragraph-1" fontWeight="bold">
                                {licensedto}
                            </Text>
                        </Flex>
                    )}
                </Flex>
            }
            footer={
                <Flex justifyContent="flex-end" componentClasses={styles.dialogFooter}>
                    {canCancel && (
                        <Button skin="secondary" size="medium" wideButton onClick={handleClose}>
                            {getLocalizedText(texts.cancel)}
                        </Button>
                    )}
                    <Button
                        skin="primary"
                        size="medium"
                        wideButton
                        onClick={onConfirm}
                        {...createDataTestId(confirmBtnDataTestId, true)}
                    >
                        {getLocalizedText(texts.ok)}
                    </Button>
                </Flex>
            }
        />
    ) : null;
});
